/*!
 * Copyright (c) 2026 GS Elektromedizinische Geraete G. Stemple GmbH, Germany - all rights reserved.
 * <p>
 * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
 */

@use '../../../../mixins';

#card-injury-accident-mechanism .row {
  justify-content: space-between;
  > div {
    width: 30%;
    div.MuiFormControl-root.MuiTextField-root {
      width: 100%;
    }
  }
}
